import { toast } from "react-hot-toast";

import { selectActiveNotifications } from "../../state/selectors";
import { dispatch, getState } from "../../state/store";
import { pushActiveNotification } from "../../state/ducks";

import { strCode } from "../../consts";
import { t } from "../../services";

import { Notification } from "../../components";

const handleNotificationLimitations = (title, message) => {
  const activeNotifications = selectActiveNotifications()(getState());

  const notificationIdsToRemove = [];

  const duplicatedNotificationIds = activeNotifications
    .filter((n) => n.title === title && n.message === message)
    ?.map((n) => n.id);

  notificationIdsToRemove.push(...duplicatedNotificationIds);

  if (activeNotifications?.length - notificationIdsToRemove?.length >= 2) {
    const oldNotificationIds = activeNotifications
      .filter((n) => !notificationIdsToRemove.includes(n.id))
      .slice(0, -1)
      .map((n) => n.id);

    notificationIdsToRemove.push(...oldNotificationIds);
  }

  if (notificationIdsToRemove.length) {
    notificationIdsToRemove.forEach((id) => toast.dismiss(id));
  }
};

const showNotification = ({
  title,
  message,
  Component,
  type = "error",
  timeout,
  infinite = false
}) => {
  handleNotificationLimitations(title, message);

  return toast.custom((t) => {
    t.duration = infinite ? Infinity : timeout;

    dispatch(pushActiveNotification({ id: t.id, title, message }));

    return (
      <div className={`${t.visible ? "animate-enter" : "animate-leave"}`}>
        <Notification
          id={t.id}
          type={type}
          title={title}
          message={message}
          Component={Component}
          closeNotification={() => toast.dismiss(t.id)}
        />
      </div>
    );
  });
};

const showError = (
  { title = t(strCode.ERROR), message = t(strCode.GLOBAL_ERROR), Component, infinite = false } = {},
  timeout = 5000
) => showNotification({ title, message, Component, type: "error", timeout, infinite });

const showSuccess = (
  { title = t(strCode.SUCCESS), message = "", Component, infinite = false } = {},
  timeout = 5000
) => showNotification({ title, message, Component, type: "success", timeout, infinite });

const notificationService = {
  showError,
  showSuccess
};

export default notificationService;
